export async function api(path, { method = "GET", body } = {}) {
  const headers = { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" };
  if (body) headers["Content-Type"] = "application/json";
  const response = await fetch(`/api/${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined, credentials: "same-origin" });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || result.errors?.join(" · ") || "La demande n’a pas abouti.");
  return result;
}
